import React from 'react'
import { WinnersList } from './list/page'

export const NewYear2026WinnersPage = () => {
  return <WinnersList />
}
